var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider-item-bottom-container" },
    [
      _c(
        "div",
        {
          staticClass: "jackpot-holder",
          class: ["jackpot-holder-" + _vm.gameId]
        },
        [
          (_vm.section &&
            !["tmu", "tcp", "tmw", "tml"].includes(_vm.section)) ||
          !_vm.section
            ? _c("span", { staticClass: "jackpot-box hidden" }, [
                _c("span", { staticClass: "jackpot-currency" }),
                _vm._v(" "),
                _c("span", { staticClass: "jackpot-amount" })
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.gameInfoLoading
        ? _c("div", {
            class: [
              { "game-info": !_vm.show },
              { "game-info-active": _vm.show }
            ],
            on: {
              click: function($event) {
                return _vm.showHideInfo()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.gameInfoLoading
        ? _c("circle-loader", { staticClass: "game-info-loader" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _vm.show
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-width": 247,
                    "nudge-bottom": 25,
                    left: true,
                    "offset-overflow": true,
                    "offset-y": "",
                    "content-class": "game-info-details"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [_c("div", { ref: "triggerClick" })]
                        }
                      }
                    ],
                    null,
                    false,
                    1602288622
                  ),
                  model: {
                    value: _vm.show,
                    callback: function($$v) {
                      _vm.show = $$v
                    },
                    expression: "show"
                  }
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "game-info-content" },
                    [
                      _vm.gameInfoData.name
                        ? _c("div", { staticClass: "game-info-name" }, [
                            _vm._v(_vm._s(_vm.gameInfoData.name))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "game-info-body" }, [
                        _c("div", { staticClass: "game-info-container" }, [
                          _c("div", { staticClass: "game-info-group" }, [
                            _c(
                              "div",
                              { staticClass: "game-info-group-item" },
                              [
                                _vm.gameInfoData.reels
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-info-group-item-name"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Casino.InfoData.Reels")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "game-info-group-item-value"
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "game-info-group-item" },
                              [
                                _vm.gameInfoData.lines || _vm.gameInfoData.ways
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-info-group-item-name"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.gameInfoData.ways
                                                ? _vm.$t("Casino.InfoData.Ways")
                                                : _vm.$t(
                                                    "Casino.InfoData.Lines"
                                                  )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-info-group-item-value"
                                        },
                                        [_vm._v(_vm._s(_vm.gameInfoData.lines))]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "game-info-group-item" },
                              [
                                _vm.gameInfoData.rtp
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-info-group-item-name"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Casino.InfoData.RTP")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-info-group-item-value"
                                        },
                                        [_vm._v(_vm._s(_vm.gameInfoData.rtp))]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "game-info-group" },
                            [
                              _vm.gameInfoData.volatility
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "game-info-group-item volatility-container"
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "volatility-scale"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "volatility-pointer"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "volatility-label-box"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "volatility-label-tile"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Casino.InfoData.Volatility"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div")
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "game-info-group-item game-launcher"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "play_btn",
                                      attrs: {
                                        disabled:
                                          _vm.isLoggedIn && !_vm.isGeolocated
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.startCasinoLauncher(
                                            _vm.gameId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isLoggedIn
                                            ? _vm.$t("Casino.InfoData.Play")
                                            : _vm.$t(
                                                "Casino.InfoData.LoginAndPlay"
                                              )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.gameInfoData.volatilityName
                            ? _c(
                                "div",
                                { staticClass: "volatility-label-value" },
                                [
                                  _c("div", { staticClass: "vol-label-val" }, [
                                    _vm._v(
                                      _vm._s(_vm.gameInfoData.volatilityName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "vol-label-val" })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "game-info-group features" },
                            [
                              _vm._l(_vm.gameInfoData.features, function(
                                feature
                              ) {
                                return _vm.gameInfoData.features
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "feature-item" },
                                        [_vm._v(_vm._s(feature))]
                                      )
                                    ]
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleRTPstore()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Casino.RTP.Info")))]
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ed8fd59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed8fd59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoJackpotAndGameInfoSection.vue
// module id = null
// module chunks = 